// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { inputFileToBase64 } from './formDataToJson';

export const formatDateTime = (dateString: string, options: { includeSeconds?: boolean; includeComma?: boolean } = null) => {
    options = { includeComma: true, ...options }; // default to using the comma, as we were before.
    if (dateString) {
        const date = new Date(dateString);
        const opts: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
        };

        if (options && 'includeSeconds' in options && options['includeSeconds']) {
            opts['second'] = 'numeric';
        }

        let dateTime = new Intl.DateTimeFormat('en-US', opts).format(date) + ' EST';

        !options.includeComma && (dateTime = dateTime.replace(',', '')); // remove comma if we don't want it

        return dateTime;
    } else {
        return 'N/A';
    }
};

export const formatDate = (dateString: string) => {
    if (dateString) {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
        }).format(date);
    } else {
        return 'N/A';
    }
};

export const formatPhone = (phone: string) => {
    const cleaned = ('' + phone).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return ['(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
};

export const formatSignatureRequest = async (signatureType: 'signature' | 'initials', signatureChanges: any, dealerId?: number) => {
    if (!signatureChanges) {
        return null;
    }

    const formData: FormData = new FormData();

    formData.append('dealerId', `${dealerId}`);
    formData.append(
        'userFields',
        JSON.stringify({
            legalName: signatureChanges.legalName,
        })
    );

    let base64File;

    if (signatureType === 'signature' && signatureChanges.signature) {
        formData.append(
            'pointData',
            JSON.stringify({
                signature: signatureChanges.signature.pointData,
            })
        );

        base64File = await inputFileToBase64(signatureChanges.signature.image);

        formData.append(
            'file',
            JSON.stringify({
                base64File,
                filename: 'digital-signature.jpg',
                contentType: 'image/jpeg',
            })
        );
    }

    if (signatureType === 'initials' && signatureChanges.initials) {
        formData.append(
            'pointData',
            JSON.stringify({
                signature: signatureChanges.initials.pointData,
            })
        );

        base64File = await inputFileToBase64(signatureChanges.initials.image);

        formData.append(
            'file',
            JSON.stringify({
                base64File,
                filename: 'digital-signature.jpg',
                contentType: 'image/jpeg',
            })
        );
    }

    return formData;
};
